(function($) {

    $('.product_faqs .faq_item').on('click', function(){
        if($(this).hasClass('active')){
            $('.product_faqs .faq_item').not($(this)).removeClass('active');

            if($(this).children('.faq_content').css('display') == 'block'){
                $(this).children('.faq_content').slideToggle();
            }
        }
        else{
            $('.product_faqs .faq_item').removeClass('active');

            $('.product_faqs .faq_item .faq_content').each(function(){
                if($(this).css('display') == 'block'){
                    $(this).slideToggle();
                }
            });

            $(this).children('.faq_content').slideToggle();
        }
        $(this).toggleClass('active');
    });
})(jQuery);